import { gsap, ScrollTrigger } from "gsap/all";
gsap.registerPlugin(ScrollTrigger);

export default class DecoParallax {

  constructor() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    const slowElements = document.querySelectorAll('.deco-top-left, .deco-top-right');
    slowElements.forEach((el) => {
      gsap.to(el, {
        y: () => -window.innerHeight * 0.15,
        ease: 'none',
        scrollTrigger: {
          trigger: document.body,
          start: 'top top',
          end: 'bottom bottom',
          scrub: 1,
        },
      });
    });

    const bottomElement = document.querySelector('.deco-bottom-left');
    if (bottomElement) {
      gsap.fromTo(bottomElement,
        { y: () => window.innerHeight * 0.12 },
        {
          y: 0,
          ease: 'none',
          scrollTrigger: {
            trigger: document.body,
            start: () => 'bottom bottom+=' + window.innerHeight * 0.6,
            end: 'bottom bottom',
            scrub: 1,
          },
        }
      );
    }
  }

}
